import React from "react";
import PropTypes from "prop-types";
import { ClaimList } from "./ClaimList";
import { useTranslation } from "react-i18next";
import { Pagination } from "antd";

const ClaimSubmissionForm = ({
  isLoading,
  onAdd,
  onView,
  isFromAdmin = false,
  data,
  onAttachmentClicked,
  setCurrentYear,
  pagination,
  setPagination,
  resetPagination,
}) => {
  const { t } = useTranslation();
  const footerElement = (footerValue, totalPagination) => (
    <div style={{ textAlign: "right", marginRight: "10px" }}>
      <Pagination
        style={{ display: "inline-flex", paddingRight: 10 }}
        defaultCurrent={pagination.current}
        current={pagination.current}
        total={totalPagination}
        onChange={onChangePagination}
        showTotal={(total) =>
          t("general.total") + ` ${total} ` + t("general.records")
        }
        defaultPageSize={pagination.pageSize}
        pageSize={pagination.pageSize}
      />
      {t("general.total")} :{" "}
      <b style={{ color: "#0070cc" }}>
        {data.length && data[0] ? data[0].FuncCurrSymb + " " : ""}
        {footerValue}
      </b>
    </div>
  );

  function onChangePagination(page, pageSize) {
    setPagination({
      current: page,
      minIndex: (page - 1) * pageSize,
      maxIndex: page * pageSize,
      pageSize: pageSize,
    });
  }

  return (
    <div>
      <ClaimList
        isLoading={isLoading}
        data={data}
        onAdd={onAdd}
        onItemViewed={onView}
        isFromAdmin={isFromAdmin}
        isShowStatus={true}
        footerElement={footerElement}
        onAttachmentClicked={onAttachmentClicked}
        setCurrentYear={setCurrentYear}
        pagination={pagination}
        setPagination={setPagination}
        resetPagination={resetPagination}
      />
    </div>
  );
};

ClaimSubmissionForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  onAdd: PropTypes.func,
  onView: PropTypes.func.isRequired,
  isFromAdmin: PropTypes.bool,
  onAttachmentClicked: PropTypes.func.isRequired,
  setCurrentYear: PropTypes.func.isRequired,
  pagination: PropTypes.object,
  setPagination: PropTypes.func,
  resetPagination: PropTypes.func,
};

export default ClaimSubmissionForm;
